<template>
  <div class="bg">
    <div class="btn-back">
      <el-button style="width: 200px" icon="el-icon-caret-left" round type="danger" @click="$router.back()"> 返回
      </el-button>
      <el-button style="width: 200px" icon="el-icon-s-home" round type="warning"
                 @click="$router.push({name:'welcome'})"> 首页
      </el-button>
    </div>
  </div>
</template>

<script>
export default { name: 'notFind' }
</script>

<style scoped type="scss">
.bg {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  position: fixed;
  background-image: url("../assets/images/system/404(1).jpg");
  display: flex;
  justify-content: center;
}

.btn-back {
  position: absolute;
  left: calc(50% - 215px);
  bottom: 11%;
}
</style>
